import { useEffect, useState } from "react";
import { _IndirectCostType, _single } from "../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE } from "../../theme/Component/BasicTable";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { Modal } from "../../theme/Component/Modal";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { SelectAccountantTree } from "../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { CostingCenterSelect } from "../../erp/cellEditor/CostingCenter/CostingCenterSelect";
import { toast } from "react-toastify";
import { SelectCostConstants } from "./SelectCostConstants";
import { BasicButton } from "../../theme/Component/BasicButton";
import { FileInput } from "../../theme/Component/FileInput";
import { _ImporIndirectCosts } from "../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../theme/Component/usePaginator";

export const IndirectCostType = () => {

    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_IndirectCostType);
    const ImporIndirectCosts = useDataBean(_ImporIndirectCosts)
    const [type, settype] = useState<any>(null);
    const [regexStr, setregexStr] = useState<string>(null)
    const [modalimp, setModalimp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();

    useEffect(() => {
        getLista()
    }, [paginador.page])

    const getLista = () => {
        instance.getIndirectCostTypeCatalogvdos(null, type, regexStr, paginador.page, 15).then(
            (resp: any) => {
                //console.log(resp.NumberOfPages)
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15)

                setLista(resp.List)
            }
        ).catch(
            err => { console.log(err) }
        )
    }
    const imporIndirectCosts = () => {
        ImporIndirectCosts.instance.imporIndirectCosts(ImporIndirectCosts.bean.Media, ImporIndirectCosts.bean.MediaContext, null, _single.getAccountID()).then(
            (rta: any) => {
                console.log(rta)
                toast.success('Importado')
                setModalimp({ ...modalimp, "view": false });
            }
        ).catch(
            err => { console.log(err) }
        )
    }
    const editaItem = () => {
        update().then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteObjec = () => {
        deleteItemVoid(bean.IDIndirectCostType).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDIndirectCostType', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Tipo Costo', property: 'TypeName', visible: true },
        { title: 'Cuenta Contable WIP', property: 'WIPAccountantIDStrName', visible: true },
        { title: 'Cuenta Contable Costo', property: 'AccountantIDStrName', visible: true },
        // { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Empleado', property: 'EmployeeName', visible: true },
    ]

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true, "name": "Agregar Costo Indirecto" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Costo Indirecto" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Costo Indirecto` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem();
        }
    }
    const vercosto = () => {

        setModalimp({ ...modalimp, "view": true });
    }
    const validateForm = () => {
        const requiredFields = [
            "Name", "AccountantIDStr", "IDEmployee"
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicPage titulo="Costos Directos e Indirectos" >
                    <div className="row">
                        <div className="col-md-4">
                            <SelectCostConstants idSelector={type} onChange={(e) => { settype(e) }} />
                        </div>
                        <div className="col-md-2">
                            <label>Búsqueda por Texto</label>
                            <input type="text" name="Name" className="form-control" value={regexStr} onChange={(e: any) => { setregexStr(e.target.value) }} />
                        </div>
                        <div className="col-md-2 mt-4 p-2">
                            <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                                Buscar
                            </BasicButton>
                        </div>
                        <div className="col-md-4 mt-4 p-2">
                            <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={vercosto}>
                                Importar Costos
                            </BasicButton>
                        </div>
                        <div className="col-md-12">
                            <BasicTable listButtons={listaBotones()} head={head} body={lista} rowSet={setBean} iconButtons={iconButtonsItem} pageTop={paginador.page}
                                next={paginador.next}
                                back={paginador.back}
                                records={paginador}
                                customRows={15} />
                        </div>
                    </div>
                </BasicPage>
            </div>

            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteObjec}>
                    <strong>Eliminar Informacion de {bean.IDIndirectCostType} - {bean.Name}</strong>
                </ModalConfirm>
            </div>
            <div className="col-md-12">
                <Modal modal={modalimp} updateModal={setModalimp} eventModal={imporIndirectCosts}>
                    <div className="row">
                        <div className="col-md-12">
                            <FileInput
                                label='Archivo a Importar'
                                directory='DocIndirecCosstType'
                                onCreate={({ Media, MediaContext }) => { ImporIndirectCosts.setBean({ ...ImporIndirectCosts.bean, "Media": Media, "MediaContext": MediaContext }) }}
                            />
                        </div>
                    </div>
                </Modal>
            </div>
            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-6">
                            <label>Nombre</label>

                            <input type="text" className="form-control" name="Name" value={bean.Name} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Cuenta Contable WIP</label>
                            <SelectAccountantTree label=" " jsonCode={bean.WIPAccountantIDStr} onChange={(e) => { setBean({ ...bean, "WIPAccountantIDStr": e.JsonCode }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Cuenta Contable</label>
                            <SelectAccountantTree label=" " jsonCode={bean.AccountantIDStr} onChange={(e) => { setBean({ ...bean, "AccountantIDStr": e.JsonCode }) }} />
                        </div>
                        <div className="col-md-6">

                            <SelectCostConstants label='Tipo Costo' idSelector={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}



